import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndProof, ExtendedTestimonials } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2rikmb2g0a59y">
      <Hero data-id="element-1" data-mp="2mjpvbd7vxaer" />
      <StatsAndProof data-id="element-2" data-mp="2mjzn96chprn3" />
      <PainPoints data-id="element-3" data-mp="31b8jhyaweb97" />
      <ProductOffer data-id="element-4" data-mp="31bs27h8dh3oa" />
      <Pricing showAnchor data-id="element-5" data-mp="31c9ts0k3atpv" />
      <ExtendedTestimonials data-id="element-6" data-mp="31cjo20c63n1d" />
      <GuaranteeAndFaq data-id="element-7" data-mp="2wjgp1comflds" />
      <CostSection data-id="element-8" data-mp="2wj8cxn0bok3n" />
      <Pricing data-id="element-9" data-mp="2wip5j08ate3v" />
      <FooterAndProofPopup data-id="element-10" data-mp="2wi5n7ieqknpb" />
      <MetaPixel data-id="element-11" data-mp="28tw6guwdqq51" />
    </main>;
}